import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./AddDocument.module.scss";
import { CloseIcon, DeleteIcon, EditIcon, PinIcon, PlusIcon, UnPinIcon } from "Assets/icons";
import ConfirmationPop from "../ConfirmationPop";
import { useCreateNoteMutation, useDeleteNoteMutation, usePinNoteMutation, useUpdateNoteMutation } from "store/services/note";
import { successMessageToast, userFullName } from "helpers/common";
import { FieldArray, Formik } from "formik";
import moment from "moment";
import { cloneDeep } from "lodash";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { store } from "store/store";
import p1 from "../../../Assets/images/user.png";
import imageLoader from "../../../Assets/images/imageLoader.gif"

const ViewAllNotes = ({ show, setShow, notes = [], client_id, module, isCreate }) => {

    const handlePopup = () => setShow(!show);

    const [createNote, { isLoading: createNoteLoading }] = useCreateNoteMutation();
    const [updateNote, { isLoading: updateNoteLoading }] = useUpdateNoteMutation();
    const [deleteNote, { isLoading: deleteNoteLoading }] = useDeleteNoteMutation();
    const [pinNote, { isLoading: pinNoteLoading }] = usePinNoteMutation();

    const lastNoteRef = useRef(null);
    const [currentItem, setCurrentItem] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [notesList, setNotesList] = useState(false);
    const [showPinModal, setShowPinModal] = useState(false);

    let setFormikValue = null;

    const user = store.getState().auth?.user;

    const handleSubmitValues = async (values) => {

        try {

            const data = { client_id, module, note: values.note }
            const result = values?.id ? await updateNote({ id: values?.id, data }) : await createNote(data);

            if (!result.error) successMessageToast(result?.data?.message);
            else console.log("Error creating/updating note")
        } catch (err) { console.log("Error creating/updating note", err) };
    };

    const handleDelete = async () => {

        try {

            let list = cloneDeep(notesList);
            list = list.filter(x => x.id != currentItem?.id);
            setFormikValue("notes", list?.length ? list : [singleNote]);

            setShowModal(false);
            const result = await deleteNote(currentItem.id);

            if (!result.error) successMessageToast(result?.data?.message);
            else console.log("Error deleting note")
        } catch (err) { console.log("Error deleting note", err) };
    };

    const handlePin = async () => {

        try {
            setShowPinModal(false);
            const data = { client_id, module };
            const result = await pinNote({ id: currentItem?.id, data });

            if (!result.error) {
                successMessageToast(result?.data?.message);
                setShow(false);
            } else {
                console.log("Error pin note");
            }
        } catch (err) { console.log("Error pin note") };
    };

    useEffect(() => {
        if (isCreate && lastNoteRef.current) {
            lastNoteRef.current.focus();
            lastNoteRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [isCreate, show]); //

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <Button
                        onClick={handlePopup}
                        className="border-0 p-0 position-absolute"
                        variant="transparent"
                        style={{ right: 10, top: 0 }}
                    >
                        <CloseIcon />
                    </Button>
                    <div>
                        <h6 className="m-0 fw-bold themeBlue">All List</h6>
                        <div className="w-100">

                            <ConfirmationPop
                                confirmation={showModal}
                                setConfirmation={setShowModal}
                                confirmHandler={handleDelete}
                                type={"delete"}
                            />
                            <ConfirmationPop
                                confirmation={showPinModal}
                                setConfirmation={setShowPinModal}
                                confirmHandler={handlePin}
                                type={currentItem?.pin_top == "Y" ? "unpin" : "pin"}
                            />
                            <Formik
                                initialValues={{ notes: isCreate ? Array.isArray(notes) && JSON.stringify(notes[0]) != JSON.stringify(singleNote) ? [...notes, { ...singleNote }] : [{ ...singleNote }] : notes }}
                                enableReinitialize
                            >{
                                    ({
                                        handleSubmit,
                                        isSubmitting,
                                        handleChange,
                                        values,
                                        errors,
                                        setFieldValue,
                                    }) => {

                                        setFormikValue = setFieldValue;
                                        setNotesList(values.notes);

                                        return (
                                            <Form onSubmit={handleSubmit}>
                                                {(createNoteLoading || updateNoteLoading || deleteNoteLoading || pinNoteLoading) && <LoadingOverlay />}
                                                <FieldArray name="notes">
                                                    {({ insert, remove, push }) => (
                                                        <ul className="list-unstyled ps-0 mb-0">
                                                            {values.notes?.length > 0 &&
                                                                values.notes.map((area, index) => {
                                                                    let isLastItem = index === values?.notes?.length - 1;

                                                                    return (
                                                                        <Row className="align-items-center my-3" key={index}>
                                                                            <Col lg="12">
                                                                                <Row>
                                                                                    <Col lg="12" sm="12">
                                                                                        <div className="student-details-main-box">
                                                                                            {
                                                                                                area.disable ? <div className="p-3 rounded shadow" style={{ border: "1px solid rgb(61, 160, 170)" }}>
                                                                                                    <p style={{ fontWeight: "700" }}>{area?.note}</p>
                                                                                                    <div className="student-details-main-notes">
                                                                                                        <div className="student-details-inner-notes d-flex align-items-center gap-2">
                                                                                                            <img
                                                                                                                src={area?.noteOwner?.therapist_detail?.profile_picture === null ? p1 : (area?.noteOwner?.therapist_detail?.profile_picture == "undefined" ? imageLoader : area?.noteOwner?.therapist_detail?.profile_picture ? area?.noteOwner?.therapist_detail?.profile_picture : p1)}
                                                                                                                // src={area?.noteOwner?.therapist_detail?.profile_picture || p1}
                                                                                                                alt=""
                                                                                                                className="img-fluid object-fit-cover rounded-circle border border-white"
                                                                                                                style={{ height: 30, width: 30 }}
                                                                                                            />
                                                                                                            {userFullName(area?.noteOwner)}
                                                                                                        </div>
                                                                                                        <div className="student-details-inner-notes">
                                                                                                            {moment(area?.createdAt).format("DD/MM/YYYY")}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div> : <textarea
                                                                                                    ref={isCreate && isLastItem ? lastNoteRef : null}
                                                                                                    className={`${styles.formControl} form-control`}
                                                                                                    style={{ minHeight: "80px" }}
                                                                                                    name={`notes.${index}.note`}
                                                                                                    value={values.notes[index]?.note}
                                                                                                    onChange={handleChange}
                                                                                                    maxLength={500}
                                                                                                    disabled={area.disable}
                                                                                                />
                                                                                            }
                                                                                            <div className="student-details-main-box-inner">
                                                                                                <div className="student-details-main-box-heading"
                                                                                                >
                                                                                                </div>
                                                                                                <Button
                                                                                                    className="border-0 p-0 d-flex align-items-center mb-2"
                                                                                                    variant="transparnet"
                                                                                                >

                                                                                                    {isLastItem && <PlusIcon onClick={() => push({ ...singleNote })} />}
                                                                                                    {(area?.id && area.disable) && <EditIcon onClick={() => {

                                                                                                        setCurrentItem(area)
                                                                                                        const list = cloneDeep([...values.notes]);
                                                                                                        list[index] = { ...list[index], disable: false }

                                                                                                        setFieldValue("notes", list)

                                                                                                    }} />}
                                                                                                    {
                                                                                                        (area.disable && user?.id == area?.addedBy) && <DeleteIcon onClick={() => {
                                                                                                            if (area.id) {
                                                                                                                setCurrentItem(area)
                                                                                                                setShowModal(true)
                                                                                                            } else remove(index)

                                                                                                        }} />
                                                                                                    }
                                                                                                    {
                                                                                                        !area.disable && <Button
                                                                                                            className="commonBtn"
                                                                                                            style={{ padding: "0", height: "30px", minWidth: "80px" }}
                                                                                                            disabled={!values.notes[index]?.note}
                                                                                                            onClick={() => {

                                                                                                                const list = cloneDeep([...values.notes]);
                                                                                                                list[index] = { ...list[index], disable: true }

                                                                                                                setFieldValue("notes", list)

                                                                                                                handleSubmitValues(area)
                                                                                                            }}
                                                                                                        >Save</Button>
                                                                                                    }
                                                                                                    {area?.id && (area?.pin_top == "Y" ? <UnPinIcon onClick={() => {
                                                                                                        setCurrentItem(area);
                                                                                                        setShowPinModal(true);
                                                                                                    }} /> : <PinIcon onClick={() => {
                                                                                                        setCurrentItem(area);
                                                                                                        setShowPinModal(true);
                                                                                                    }} />)}

                                                                                                </Button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        </Row>
                                                                    )
                                                                })}
                                                        </ul>
                                                    )}
                                                </FieldArray>
                                            </Form>
                                        )
                                    }}
                            </Formik>
                        </div >
                    </div>

                </Modal.Body>
            </Modal >
        </>
    );
};

export default ViewAllNotes;

const singleNote = {
    note: "",
    disable: false
}